import * as signalR from "@microsoft/signalr";
import { store } from "./Slices";

export const initiateSignalR = (message) => {
  const getToken = () => {
    const tokenData = store.getState()?.data?.userInfo?.data;
    return tokenData?.token || null;
  };
  const token = getToken();
  if (!token) {
    console.error("Token not found.");
    return null;
  }

  const userID = String(message?.data?.UserId);

  const URL = process.env.REACT_APP_URL_webHook;
  let connect = new signalR.HubConnectionBuilder()
    .withUrl(`${URL}chathub?userId=${userID}`)
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  connect
    .start()
    .then(() => {
      console.log("SignalR Connected!");
    })
    .catch((err) => console.error("Connection failed: ", err));

  return connect;
};
